import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CmsItem } from '@coin/shared/cms/util';
import { StripParagraphsPipe } from '@coin/shared/core/util-pipes';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';

@Component({
  selector: 'coin-news-headline',
  templateUrl: './news-headline.component.html',
  styleUrls: ['./news-headline.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HtmlEditorComponent, StripParagraphsPipe]
})
export class NewsHeadlineComponent {
  @Input() item: CmsItem<'headline-with-subheadline'>;
  @Input() contentEdit = false;
}
